import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { brandName, differenceWith, differenceWithout, keepImprovising, price, useTheSystem } from '../data/copy';
export function FinalCtaSection() {
  return <section className="defer-paint w-full bg-ink py-10 sm:py-14" aria-labelledby="final-cta-heading" data-id="element-70" data-mp="3vt5p4zp8dg7j">
      <div className="mx-auto max-w-5xl px-6" data-id="element-71" data-mp="2y5n8z3t8pbti">
        <SectionHeading title={<span id="final-cta-heading" data-id="element-73" data-mp="333yjlgrczqcs">Your next volleyball practice</span>} data-id="element-72" data-mp="2y2rb1fhe6n52" />

        <div className="mt-10 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-74" data-mp="331uif6kuh5g7">
          <div className="rounded-3xl border border-line bg-navy p-6 sm:p-7" data-id="element-75" data-mp="3829snp9txwty">
            <h3 className="font-display text-2xl font-extrabold uppercase text-fg" data-id="element-76" data-mp="3cu06w6bw14qn">
              You can keep improvising...
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-77" data-mp="2fe48p4qlobv6">
              {keepImprovising.map(item => <li key={item} className="flex items-start gap-2.5 leading-snug text-muted" data-id="element-78" data-mp="2kc60qf607lis">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" strokeWidth={2.6} aria-hidden="true" data-id="element-79" data-mp="2dayprs1hj23w" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl border-2 border-accent/60 bg-panel p-6 sm:p-7" data-id="element-80" data-mp="23lf4ygu7oy6e">
            <h3 className="font-display text-2xl font-extrabold uppercase text-accent" data-id="element-81" data-mp="1ynngjwsrzu6y">
              Or use {brandName}
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-82" data-mp="1un3j0s4aioka">
              {useTheSystem.map(item => <li key={item} className="flex items-start gap-2.5 font-medium leading-snug text-fg" data-id="element-83" data-mp="1pm602dbghqhq">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-84" data-mp="1kmjftjx7n9zf" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-12" data-id="element-85" data-mp="3f0avp164uq3b">
          <h3 className="text-center font-display text-3xl font-extrabold uppercase leading-tight text-fg sm:text-4xl" data-id="element-86" data-mp="3ez9j2s9gxvjh">
            The difference
          </h3>
          <div className="mt-8 grid overflow-hidden rounded-3xl border border-line md:grid-cols-2" data-id="element-87" data-mp="18c24tgtm8u7r">
            <div className="bg-navy" data-id="element-88" data-mp="1d4v8009fruhq">
              <p className="border-b border-line px-5 py-4 font-display text-lg font-bold uppercase tracking-wide text-muted sm:px-6" data-id="element-89" data-mp="1d5wmyftkp14q">
                Keep improvising
              </p>
              <ul className="divide-y divide-line" data-id="element-90" data-mp="13ea2rtz9brpu">
                {differenceWithout.map(item => <li key={item} className="flex items-start gap-2 px-5 py-3.5 text-[0.95rem] leading-snug text-muted sm:px-6" data-id="element-91" data-mp="1r4w99gtm53xq">
                    <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" strokeWidth={2.6} aria-hidden="true" data-id="element-92" data-mp="1w0larpp70uwo" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="border-t border-line bg-accent/[0.07] md:border-l md:border-t-0" data-id="element-93" data-mp="1m6kzt778cvg1">
              <p className="border-b border-line px-5 py-4 font-display text-lg font-bold uppercase tracking-wide text-accent sm:px-6" data-id="element-94" data-mp="6puavr8od69k">
                {brandName}
              </p>
              <ul className="divide-y divide-line" data-id="element-95" data-mp="34913ect3oiq">
                {differenceWith.map(item => <li key={item} className="flex items-start gap-2 px-5 py-3.5 text-[0.95rem] font-medium leading-snug text-fg sm:px-6" data-id="element-96" data-mp="3ub3g6g4citit">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-97" data-mp="d1x5kw07sae3" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-3xl text-center" data-id="element-98" data-mp="3blvmb2y6xa55">
          <p className="font-display text-2xl font-bold uppercase leading-tight text-muted sm:text-3xl" data-id="element-99" data-mp="3bjiyi95r45k6">
            You do not need to be the perfect volleyball coach.
          </p>
          <p className="mt-3 font-display text-2xl font-extrabold uppercase leading-tight text-fg sm:text-3xl" data-id="element-100" data-mp="3li8jwbwuw856">
            You need a system that helps you plan faster, coach with more
            structure, and give your players more meaningful repetitions.
          </p>

          <div className="mx-auto mt-8 grid max-w-md grid-cols-2 gap-x-6 gap-y-1.5 text-left font-display text-xl font-bold uppercase" data-id="element-101" data-mp="1w4sd6nz0ybjm">
            <ul className="space-y-1.5 text-muted" data-id="element-102" data-mp="2039l39q9rq23">
              <li data-id="element-103" data-mp="254705dfzg3zd">Less searching.</li>
              <li data-id="element-104" data-mp="2534at9yb69lk">Less waiting.</li>
              <li data-id="element-105" data-mp="29uvseuzhl4zk">Less improvisation.</li>
            </ul>
            <ul className="space-y-1.5 text-accent" data-id="element-106" data-mp="29wqhmlhsjj9g">
              <li data-id="element-107" data-mp="2euryr0vnp8ia">More structure.</li>
              <li data-id="element-108" data-mp="2etqkyon9a7wv">More touches.</li>
              <li data-id="element-109" data-mp="2jtbkp1a92kan">More coaching.</li>
            </ul>
          </div>

          <p className="mt-10 font-display text-4xl font-extrabold uppercase leading-[0.95] text-accent sm:text-5xl" data-id="element-110" data-mp="2jric3gg2tq00">
            Your next volleyball practice is already planned.
          </p>

          <CtaButton size="large" className="mt-9 w-full sm:w-auto" data-id="element-111" data-mp="2sthwmiqavc7p">
            Get {brandName} — {price}
          </CtaButton>
          <p className="mt-4 text-sm text-muted" data-id="element-112" data-mp="tja1kws5os2v">
            Secure payment · Instant access · 7-day guarantee
          </p>
        </div>
      </div>
    </section>;
}